export default __webpack_public_path__ + "static/media/Excellent.413a6b7b.svg";